/**
 * Dynamically updates the website's document title and favicon links.
 * Force-refreshes the browser's favicon by removing and recreating the link elements,
 * which triggers browsers (like Chrome, Safari, and Firefox) to immediately reload the tab icon.
 * 
 * @param {Object} site - The site configuration object containing title and favicon.
 * @param {string} [site.title] - The site title.
 * @param {string} [site.favicon] - The site favicon URL.
 */
export function updateSiteMetadata(site) {
  if (!site) return

  const { title, favicon } = site

  if (title) {
    document.title = title
  }

  if (favicon) {
    const parent = document.head || document.getElementsByTagName('head')[0]

    const updateFaviconLink = (rel, id) => {
      // Find the existing element
      const selector = id ? `#${id}` : `link[rel='${rel}']`
      const existingLink = document.querySelector(selector)

      if (existingLink) {
        if (existingLink.getAttribute('href') === favicon) {
          // If the href is already correct, no need to recreate/touch it
          return
        }
        // Remove old link element to force browser to uncache and repaint
        parent.removeChild(existingLink)
      }

      // Create a brand new link element to force browser refresh
      const newLink = document.createElement('link')
      newLink.rel = rel
      if (id) {
        newLink.id = id
      }
      newLink.href = favicon
      parent.appendChild(newLink)
    }

    updateFaviconLink("shortcut icon", "favicon")
    updateFaviconLink("icon")
    updateFaviconLink("apple-touch-icon")
  }
}
